import React from 'react'
import CompareTemplate from 'src/components/template/compare'
import { spectrumData } from 'src/components/template/compare/components/data/spectrumData'

export default (props) => <CompareTemplate location={props.location} data={spectrumData} />
